export default __webpack_public_path__ + "static/media/arrow-down.764eccc1.svg";